import { autoRegisterFeature } from '@store/features/factory';

import { patientCoveragesFeature } from './store/feature';

// Auto-register the feature
autoRegisterFeature(patientCoveragesFeature);

// Export everything from store
export * from './store';

// Export types
export * from './types';

// Export shared coverage UI and workflow helpers
export { CoverageGapNotice } from './components/CoverageGapNotice';
export {
  CoverageStatusChip,
  formatCoverageWindow,
} from './components/CoverageStatusChip';
export { InsuranceHistorySection } from './components/InsuranceHistorySection';
export {
  type CoverageSaveRecord,
  type PatientInsuranceAutosaveState,
  PatientInsuranceEditor,
} from './components/PatientInsuranceEditor';
export {
  SelfPayCoverageCard,
  SelfPayCoverageToggle,
  useSelfPayCoverageDesignation,
} from './components/SelfPayCoverageDesignation';

// Export eligibility status config utilities
export type { StatusConfig } from './eligibilityStatusConfig';
export { STATUS_CONFIG } from './eligibilityStatusConfig';
